<script setup>

import { ref } from 'vue';
import { getErreurTexteRequis } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['creationModele']);

const nouveauModele = ref(getModeleInitial());

function getModeleInitial() {
    return {
        nomModele: null,
        nomCampagne: 'Tests'
    };
}

function validerSaisie(modele) {
    const erreurs = {};
    erreurs.nomModele = getErreurTexteRequis(modele.nomModele);
    erreurs.nomCampagne = getErreurTexteRequis(modele.nomCampagne);
    return erreurs;
}

function validerFormulaire() {
    nouveauModele.value.validationFormulaire = true;
}

function valider() {
    emit('creationModele', nouveauModele.value);
}

</script>

<template>
    <Dialog 
    v-model:visible="visible" 
    modal 
    header="Nouveau modèle">
        <Formulaire 
            :objet="nouveauModele"
            :fonction-validation-saisie="validerSaisie"
            @validation="valider">
            <label class="intitule">Nom du modèle :</label>
            <SaisieTexte v-model:valeur="nouveauModele.nomModele" :id-erreur="'nomModele'" :autofocus="true" />
            <label class="intitule">Campagne initiale :</label>
            <SaisieTexte v-model:valeur="nouveauModele.nomCampagne" :id-erreur="'nomCampagne'" />
        </Formulaire>
        <template #footer>
            <button 
                class="bouton btn-primaire fas fa-check" 
                @click="validerFormulaire()"/>
        </template>
    </Dialog>
</template>

<style scoped>

</style>